import { render, staticRenderFns } from "./proof-of-payment-widget.vue?vue&type=template&id=2382006c&"
import script from "./proof-of-payment-widget.vue?vue&type=script&lang=js&"
export * from "./proof-of-payment-widget.vue?vue&type=script&lang=js&"
import style0 from "./proof-of-payment-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports